import { render, staticRenderFns } from "./dy-subTab.vue?vue&type=template&id=562a04d0&scoped=true"
import script from "./dy-subTab.vue?vue&type=script&lang=js"
export * from "./dy-subTab.vue?vue&type=script&lang=js"
import style0 from "./dy-subTab.vue?vue&type=style&index=0&id=562a04d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a04d0",
  null
  
)

export default component.exports